import React, { useState } from 'react';
import ECardAllFiles from './ECardAllFiles';
import { ECardView } from '../../Enums/ECardView.enum';
import useTranslation from '../../../../Hooks/useTranslation';
import { useLazyDocumentationFilesCountQuery } from '../../../../graphql/graphql';
import { FileToShare } from '../ECard/ECard';
import { useEffectAsync } from '../../../../helpers';

// @ts-ignore
import styles from './ECardAllFilesWrapper.module.scss';
import { ECardType } from '../../Enums/ECardType.enum';

interface Props {
	setIsAllFilesToggled: (isAllFilesToggled: boolean) => void;
	isAllFilesToggled: boolean;
	view: ECardView;
	patientId: string;
	filter?: string;
	isShareMode: boolean;
	onItemCheck: (file: FileToShare, isChecked: boolean) => void;
	filesToShare: FileToShare[];
	reloadEvent?: (() => void)[];
	eCardType: ECardType;
}

const ECardAllFilesWrapper: React.FC<Props> = ({
	patientId,
	isAllFilesToggled,
	setIsAllFilesToggled,
	view,
	filter,
	isShareMode,
	onItemCheck,
	filesToShare,
	reloadEvent,
	eCardType,
}) => {
	const [getFileCount] = useLazyDocumentationFilesCountQuery();
	const [fileCount, setFileCount] = useState<number>(0);
	const { t } = useTranslation();

	const loadData = async () => {
		if (patientId) {
			const { documentationFiles } = await getFileCount({
				userId: patientId,
				fulltext: filter,
			}).unwrap();

			setFileCount(documentationFiles?.meta?.count ?? 0);
		}
	};

	reloadEvent?.push(loadData);

	useEffectAsync(async () => {
		await loadData();
	}, [filter]);

	if (isAllFilesToggled) {
		return (
			<>
				<div
					className={styles.button}
					onClick={() => setIsAllFilesToggled(false)}>
					<img src={'/dist/icons/share-solid.svg'} alt='Share icon' />
					<div>{t('component.eCard.backToFoldersList')}</div>
				</div>
				<ECardAllFiles
					patientId={patientId}
					view={view}
					filter={filter}
					isShareMode={isShareMode}
					onItemCheck={onItemCheck}
					filesToShare={filesToShare}
					eCardType={eCardType}
				/>
			</>
		);
	}
	return (
		<div className={styles.button} onClick={() => setIsAllFilesToggled(true)}>
			<img src={'/dist/icons/folder-solid.svg'} alt='Folder icon' />
			<div>
				{t('component.eCard.allFiles')} ({fileCount})
			</div>
		</div>
	);
};

export default ECardAllFilesWrapper;
